export default {
  report360: null,
  report360Compare: null,
  reportPersonal: null,
  reportBHPersonal: null,
  reportBHPersonalTeam: null,
  reportSelf: null,
  reportSelfVersions: null,
  reportTeam: null,
  reportTeamSpecs: null,
  teamsPersonal: null,
  teamsBHPersonal: null,
  reportParams: null,
  commentsParams: null,
  reportLink: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
